const bookChoicesSrb = [
  {
    label: "Узбудљиве авантуре и лагане пријатне приче.",
    value:
      'Exciting adventures and light enjoyable stories.{"Red":"3","Yellow":"2"}',
  },
  {
    label: "Мрачне приче и филозофска, размишљајућа дела.",
    value:
      'Mysteries and dark stories and philosophical, contemplative works.{"Black":"3","Gray":"2"}',
  },

  {
    label: "Инспиративне приче о отпорности и дирљивим породичним наративима.",
    value:
      'Inspiring stories of resilience and moving family narratives.{"Green":"3","Brown":"2"}',
  },

  {
    label:
      "Дубоки, размишљајући романи и фантазијске приче са магичним елементима.",
    value:
      'Deep, contemplative novels and fantasy stories with magical elements.{"Blue":"3","Violet":"2"}',
  },
];

export default bookChoicesSrb;
